var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68935 0H6.08485C7.50132 0 8.6365 1.15 8.6365 2.561V5.97C8.6365 7.39 7.50132 8.53 6.08485 8.53H2.68935C1.28292 8.53 0.137695 7.39 0.137695 5.97V2.561C0.137695 1.15 1.28292 0 2.68935 0ZM2.68935 11.4697H6.08485C7.50132 11.4697 8.6365 12.6107 8.6365 14.0307V17.4397C8.6365 18.8497 7.50132 19.9997 6.08485 19.9997H2.68935C1.28292 19.9997 0.137695 18.8497 0.137695 17.4397V14.0307C0.137695 12.6107 1.28292 11.4697 2.68935 11.4697ZM17.6777 0H14.2822C12.8658 0 11.7306 1.15 11.7306 2.561V5.97C11.7306 7.39 12.8658 8.53 14.2822 8.53H17.6777C19.0842 8.53 20.2294 7.39 20.2294 5.97V2.561C20.2294 1.15 19.0842 0 17.6777 0ZM14.2822 11.4697H17.6777C19.0842 11.4697 20.2294 12.6107 20.2294 14.0307V17.4397C20.2294 18.8497 19.0842 19.9997 17.6777 19.9997H14.2822C12.8658 19.9997 11.7306 18.8497 11.7306 17.4397V14.0307C11.7306 12.6107 12.8658 11.4697 14.2822 11.4697Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.d08f39e70258bdcc54698d254ce2d168.svg";
export { ForwardRef as ReactComponent };